import { render } from "./BaseValidationErrors.vue?vue&type=template&id=c4932646"
import script from "./BaseValidationErrors.vue?vue&type=script&lang=js"
export * from "./BaseValidationErrors.vue?vue&type=script&lang=js"
script.render = render

export default script